import { toast } from 'react-toastify'

import { createAxiosInstance, getModificaciones, indexBy } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import { displayMessages, uploadFiles, showHideModalCreateOtrosi} from './common'
import { isFunction } from '../utils/helpers'


import moment from 'moment'

import { createOtrosi } from './otrosi'


export function showHideModalSummary(show, id, url, type) {
    return (dispatch) => {
		if (show) {
            const fn1 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_DOCUMENTO, payload: { show, url, type }})
            const fn0 = d => d(getDocumento(id, fn1))
            fn0(dispatch)
		} else {
			const fn2 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_DOCUMENTO, payload: { show }})
			fn2(dispatch)
		}
    }
}

export function getDocumento(id, next) {    
	const axios = createAxiosInstance()
    return (dispatch) => {
        axios.get(`${API_URL}/documentos`, { params: { id }})
        .then((res) => {
            const fn1 = d => d({ type: types.ACTUALIZAR_MODAL_SUMMARY_DOCUMENTO, payload: res.data })
            fn1(dispatch)
            if (isFunction(next)) next(dispatch)
        })
        .catch((err) => {
            console.log(err)
			const fn2 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_DOCUMENTO, payload: { show: false }})
			fn2(dispatch)
            displayMessages(dispatch, err)
        })
    }
}



export function showHideModalCreateEntrega(show, id = null) {
	const axios = createAxiosInstance()

    return (dispatch) => {
        if (show) {
            axios.get(`${API_URL}/parametros`, { params: { nombre: 'CRITERIOS_EVALUACION_PROVEEDORES' }})
            .then(res => {
                const criterios = res.data.reduce((a, b) => {
                    a[b.CRITERIO] = b
                    return a
                }, {})
                const fn0 = d => d({ type: types.MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO, payload: { show, criterios, id }})
                fn0(dispatch)
            })
            .catch(err => {
                console.log(err)
                displayMessages(dispatch, err)
            })
        } else {
            const fn0 = d => d({ type: types.MOSTRAR_MODAL_CREAR_ENTREGA_DOCUMENTO, payload: { show }})
            fn0(dispatch)
        }
    }
}


export function showHideModalCreateVerificacion(show, index) {
    return (dispatch, getState) => {
        const fn0 = d => d({ type: types.MOSTRAR_MODAL_CREAR_VERIFICACION_SOMA_DOCUMENTO, payload: { show, index }})
        fn0(dispatch)
    }
}



export function updateInputs(path, value, id = null, immutable = true, tipo_solicitud) {
	return (dispatch, getState) => {

        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_DOCUMENTOS, payload: { path, value, immutable } })
        fn0(dispatch)


		if ((path === 'modalAddAdicional.data.iva' || path === 'modalAddAdicional.data.valor') && tipo_solicitud !== 3) {

			const iva = getState().documentos.getIn('modalAddAdicional.data.iva'.split('.'))
			const valor = getState().documentos.getIn('modalAddAdicional.data.valor'.split('.'))
           //const valor_con_iva = Math.round(valor * (1 + (iva / 100)))              
            const valor_con_iva = valor * (1 + (iva / 100))
			const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_DOCUMENTOS, payload: { path: 'modalAddAdicional.data.valor_con_iva', value: valor_con_iva } })
            fn1(dispatch)
            
        }  

	}
}



export function removeFactura() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
        
        const data = getState().documentos.get('modalSummary')

        const documento = data.get('data')
        const document_id = data.getIn(['data', 'id'])
        const solicitud_id = data.getIn(['data', 'solicitud_id'])
        const facturas = data.getIn(['data', 'facturas'])
        const url = data.get('url')
        const type = data.get('type')
        
        let modificaciones = []

        facturas.map(f => {
            if (f.get('selected')) {
                const ev = f.getIn(['entrega','evaluaciones']);
                ev && f.getIn(['entrega','evaluaciones']).map(ev => {
                    modificaciones.push({
                        entity: 'Evaluacione',
                        id: ev.get('id'),
                        action: 'delete'
                    })
                });
                if (f.get('adjunto')) {
                    modificaciones.push({
                        entity: 'Adjunto',
                        id: f.getIn(['adjunto', 'id']),
                        action: 'delete'
                    })
                }
                modificaciones.push({
                    entity: 'Factura',
                    id: f.get('id'),
                    action: 'delete',
                    value: {
                        documento_id: document_id
                    }
                })
                modificaciones.push({
                    entity: 'Entrega',
                    id: f.get('entrega_id'),
                    action: 'delete'
                });
                modificaciones.push({
                    entity: 'CodigoRadicacion',
                    id: f.getIn(['radicado', 'id']),
                    action: 'delete'
                })

            }
        })
        

        //Revertimos los estados

        modificaciones.push({
            id: solicitud_id,
            entity: 'Solicitude',
            value: {
                estado: 6
            },
            action: 'edit'
        })

        modificaciones.push({
            id: document_id,
            entity: 'Documento',
            value: {
                estado: 10
            },
            action: 'edit'
        })


        const amortizaciones = facturas.filter(f => f.get('selected')).reduce((acc, current) => acc+current.get('amortizacion'), 0)
        modificaciones = revertirAmortizaciones(amortizaciones, documento, modificaciones)


        
        axios.put(`${API_URL}/${url}`, modificaciones)
            .then(res => {
                const solicitud = res.data.solicitud
                const aprobadores = res.data.aprobadores
                const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores } });                
                fn2(dispatch)
                dispatch(getDocumento(document_id))
                displayMessages(dispatch, { success: 'Las factura(s) han sido eliminada(s) exitosamente' })
            })
            .catch(err => {
                console.log(err)
                displayMessages(dispatch, err)
            })
            
	}
}


export function createOrUpdateDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {


		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS, payload: true }) //No aparece en actions creators
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_CREAR_ENTREGA_DOCUMENTOS, payload: false })
		fn0(dispatch)

        const data = getState().documentos.get('modalCreateEntrega')
        const url = data.get('url')
        const type = data.get('type')
		let objNew = data.get('data')
        let objOld = data.get('unchanged')

        const entregas_parciales = getState().documentos.getIn(['modalSummary', 'data', 'entregas_parciales']);



		const errors = validateEntrega(objNew, entregas_parciales)
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			objOld = objOld.set('evaluaciones', indexBy(objOld.get('evaluaciones'), 'id'))
			objNew = objNew.set('evaluaciones', indexBy(objNew.get('evaluaciones'), 'id'))

            const modificaciones = getModificaciones(objNew, objOld, 'Entrega', switchEntrega)
            

            axios.put(`${API_URL}/${url}`, modificaciones)
                .then(res => {

                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores } })
                    
                    fn2(dispatch)
                    dispatch(showHideModalCreateEntrega(false))
                    dispatch(getDocumento(objNew.get('documento_id')))
                    displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
                })
                .catch(err => {
                    console.log(err)
                    displayMessages(dispatch, err)
                    fn1(dispatch)
                })
		}
	}
}



export function updateDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

        const data = getState().documentos.getIn(['modalSummary', 'data'])
        const url = getState().documentos.getIn(['modalSummary', 'url'])
        const type = getState().documentos.getIn(['modalSummary', 'type'])
        const documento_id = data.get('id')
        
        
        const modificaciones = []
        
        const detalles = data.get('todos_detalles')

        detalles.valueSeq().forEach(detalle => {
			modificaciones.push({
				id: detalle.get('id'),
				entity: 'DocumentoDetalle',
				value: {
					valor: Number(detalle.get('valor')),
					valor_con_iva: Number(detalle.get('valor_con_iva'))
				},
				action: 'edit'
			})
        })        
        


        axios.put(`${API_URL}/${url}`, modificaciones)
            .then(res => {

                const solicitud = res.data.solicitud
                const aprobadores = res.data.aprobadores
                const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores } })
                
                fn2(dispatch)
                dispatch(showHideModalCreateEntrega(false))
                dispatch(getDocumento(documento_id))
                displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
                dispatch(updateInputs('modalSummary.editar', false))

            })
            .catch(err => {
                console.log(err)
                displayMessages(dispatch, err)
            })
        



	}
}




export function cancelDocumento() {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

        const data = getState().documentos.get('modalSummary')
        const url = data.get('url')
        const type = data.get('type')
		let documento = data.get('data')

        const errors = validateCancelacion(documento)        
        
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

            const modificaciones = []
            
			modificaciones.push({
				id: documento.get('id'),
				entity: 'Documento',
				attribute: 'estado',
				value: 0,
				action: 'edit'
            })

            modificaciones.push({
				id: documento.get('id'),
				entity: 'Documento',
				attribute: 'fecha_cancelacion',
				value: moment().format('YYYY-MM-DD'),
				action: 'edit'
            })

			modificaciones.push({
				id: documento.get('id'),
				entity: 'Documento',
				attribute: 'motivo_cancelacion',
				value: documento.get('motivo_cancelacion'),
				action: 'edit'
            })            



            axios.put(`${API_URL}/${url}`, modificaciones)
                .then(res => {
                    const solicitud = res.data.solicitud
                    const aprobadores = res.data.aprobadores
                    const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores} })
                    fn2(dispatch)
                    //dispatch(showHideModalSummary(false))
                    dispatch(getDocumento(documento.get('id')))
                    displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
                })
                .catch(err => {
                    console.log(err)
                    displayMessages(dispatch, err)
                })

		}
	}
}








export function addFile(url, documentoId, actions) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile','data'])
        let files = [data]
        files = files.map(f => {
            f = f.set('documento_id', documentoId)
            return f
        })
    	dispatch(uploadFiles(url, files, actions))
	}
}

export function removeFiles() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const fns = []
		getState().documentos.getIn(['modalSummary', 'data', 'adjuntos']).filter(a => a.get('id') && a.get('selected')).forEach(a => {
			fns.push(() => axios.delete(`${API_URL}/files/${a.get('id')}`))
		})
		Promise.all(fns.map(x => x()))
		.then(res => {
            dispatch({ type: types.ELIMINAR_ARCHIVOS_DOCUMENTO })
			displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}

export function showHideModalAddAdicional(show, documento, url, type) {
    return (dispatch) => {
        const fn0 = d => d({ type: types.MOSTRAR_MODAL_ADICIONAR_ADICIONAL, payload: { show, documento, url, type }})
        fn0(dispatch)
    }
}

export function addCencoItem() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_CENCO_ADICIONAL })
	}
}

export function removeCencosItem() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_CENCOS_ADICIONAL })
	}
}

export function storeAdicion() {
    const axios = createAxiosInstance()
    
    return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADICIONAR_ADICION, payload: false })
        fn0(dispatch)


        let modalAddAdicional = getState().documentos.get('modalAddAdicional')
        let adicion = modalAddAdicional.get('data')
        adicion = adicion.set('documento_id', getState().documentos.getIn(['modalSummary', 'data', 'id']))
        const type = modalAddAdicional.get('type')


        if(adicion.get('valor') &&  Math.abs(Number(adicion.get('valor'))) > Math.abs(Number(adicion.get('valor_con_iva')))) {
            fn1(dispatch)
            return toast.warning("El valor del Servicio debe ser menor al valor total.", { bodyClassName: 'toastify-content toastify-warning' })
        }

        if (Number(adicion.get('valor_con_iva')) > 0 && adicion.get('cencos').count() == 0) {
            fn1(dispatch)
            return toast.warning("Debe agregar al menos un cenco para poder ser aprobado", { bodyClassName: 'toastify-content toastify-warning' })
        }  

        if (Number(adicion.get('valor_con_iva')) > 0 && adicion.get('cencos').count() > 0) {            
            const sindefinir = adicion.get('cencos').filter(c => c.get('cenco') == null).count()
            if (sindefinir > 0) {
                fn1(dispatch)
                return toast.warning("Todos los cencos deben estar definidos", { bodyClassName: 'toastify-content toastify-warning' })
            } 
        }

        axios.post(`${API_URL}/documentos/adicion`, adicion)
            .then(res => { 

                const solicitud = res.data.solicitud
                const aprobadores = res.data.aprobadores 

                if (!res.data.otrosi) {
                    const fn2 = (d) => d({ type: type, payload: { solicitud, aprobadores} })
                    fn2(dispatch)
                    
                    dispatch(showHideModalAddAdicional(false))
                    dispatch(getDocumento(adicion.get('documento_id')))
                    displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })

                    fn1(dispatch)


                } else {

                    //dispatch(showHideModalCreateOtrosi(true, res.data.message, createOtrosi()))

                    if (adicion.get('cencos').count() == 0) {
                        fn1(dispatch)
                        return toast.warning("Debe agregar al menos un cenco para poder ser aprobado", { bodyClassName: 'toastify-content toastify-warning' })
                    }  
            
                    if (adicion.get('cencos').count() > 0) {
                        fn1(dispatch)
                        const sindefinir = adicion.get('cencos').filter(c => c.get('cenco') == null).count()
                        if (sindefinir > 0) return toast.warning("Todos los cencos deben estar definidos", { bodyClassName: 'toastify-content toastify-warning' })
                    }


                    dispatch(showHideModalCreateOtrosi(true, res.data.message, createOtrosi()))

                }

            })
            .catch(err => {
                console.log(err)
                displayMessages(dispatch, err)
                fn1(dispatch)
            })

    }
}







///******* Shared ********///

const validateEntrega = (data, entregas_parciales=false) => {
	const errors = []
    if (!data.get('fecha')) errors.push('El campo fecha entrega es obligatorio')   


    if (data.get('fecha') && moment().isBefore(data.get('fecha'))) errors.push('La fecha de entrega no debe ser superior a la de hoy')

    data.get('evaluaciones').forEach((a, b) => {
        if (a.get('calificacion') === 0 || a.get('calificacion') === null) errors.push(`El criterio ${a.get('criterio')} no ha sido calificada`)
    })

    if (entregas_parciales) {     

        if (!data.get('valor_a_facturar') || data.get('valor_a_facturar') == 0) errors.push('El campo valor a facturar es obligatorio')
        if (data.get('valor_a_facturar') < 0) errors.push('El campo valor a facturar debe ser superior a 0')
    }


	return errors
}



const validateCancelacion = (data) => {
    const errors = []
    if (!data.get('motivo_cancelacion')) errors.push('El campo motivo de cancelación es obligatorio')
	return errors
}

const switchEntrega = (change, modificacion) => {
    const path = [...modificacion.attribute]
	modificacion.attribute = path[0]
    if (modificacion.attribute === 'evaluaciones') {
        modificacion.entity = "Evaluacione"
        modificacion.id = path[1]
        modificacion.attribute = path[2]
    }
}




const revertirAmortizaciones = (amortizaciones, documento, modificaciones) => {  
    
    if (amortizaciones > 0) {

        const anticipos = []        
        
        if (documento.get('anticipo') > 0) {
            anticipos.push(documento)
        }
    
        documento.get('documentos').filter(d => d.get('tipo') == 4 && d.get('anticipo') > 0).map(x => {
            anticipos.push(x)
        }) 


        for(let i = 0; i < anticipos.length; i++) {

            const anticipo_legalizado = anticipos[i].get('anticipo_legalizado')
            
            if (amortizaciones <= anticipo_legalizado) {

                modificaciones.push({
                    id: anticipos[i].get('id'),
                    entity: 'Documento',
                    value: {
                        anticipo_legalizado: anticipo_legalizado - amortizaciones
                    },
                    action: 'edit'
                })

                amortizaciones = 0

            } else {

                modificaciones.push({
                    id: anticipos[i].get('id'),
                    entity: 'Documento',
                    value: {
                        anticipo_legalizado: 0
                    },
                    action: 'edit'
                })

                amortizaciones -= anticipo_legalizado
            }

            if (amortizaciones <= 0) {
                break
            }

        }

    }

    return modificaciones

}






// WEBPACK FOOTER //
// ./src/actions/documentos.js